import Modal from "bootstrap/js/dist/modal"
import moment from 'moment'
import { tagifyElements } from './app'
import { getSupabaseLectures } from './server/advayta'
import { showErrorToast, showOkToast } from './uiControl/toastControl'

let lecturesData = []
let selectedLecture = null

export function init() {
	const importBtn = document.getElementById('supabaseImport')
	const importLectureBtn = document.getElementById('importLectureBtn')

	importBtn.addEventListener('click', getLectures)
	importLectureBtn.addEventListener('click', importSelectedLecture)
}

async function getLectures() {
	const date = getLectureDate()

	try {
		const lectures = await getSupabaseLectures(date)

		if (!lectures.length) return showErrorToast('Лекции не найдены')

		lecturesData = lectures
		showLecturesModal()

	} catch (e) {
		showErrorToast('Ошибка получения списка лекций')
	}
}

function showLecturesModal() {
	const modal = new Modal(document.getElementById('supabaseLecturesModal'))
	const lectureData = document.getElementById('lectureData')

	createLectureCards()

	if (lecturesData.length === 1) {
		selectedLecture = lecturesData[0]
		updateLectureData()
		document.getElementById('importLectureBtn').disabled = false

		const radioButton = document.querySelector('input[name="selectedLecture"]')
		if (radioButton) {
			radioButton.checked = true
		}
	} else {
		lectureData.textContent = 'Выберите лекцию для просмотра данных'
		selectedLecture = null
		document.getElementById('importLectureBtn').disabled = true
	}

	modal.show()
}

function createLectureCards() {
	const lectureCardsContainer = document.getElementById('lectureCards')
	lectureCardsContainer.innerHTML = ''

	if (lecturesData.length === 0) {
		lectureCardsContainer.innerHTML = '<div class="text-muted text-center p-3">Лекции не найдены</div>'
		return
	}

	lecturesData.forEach((lecture, index) => {
		const card = createLectureCard(lecture, index)
		lectureCardsContainer.appendChild(card)
	})
}

function createLectureCard(lecture, index) {
	const card = document.createElement('div')
	card.className = 'card mb-3'

	const cardBody = document.createElement('div')
	cardBody.className = 'card-body'

	const radioContainer = document.createElement('div')
	radioContainer.className = 'form-check'

	const radio = document.createElement('input')
	radio.type = 'radio'
	radio.name = 'selectedLecture'
	radio.value = index
	radio.id = `lecture_${index}`
	radio.className = 'form-check-input'

	const radioLabel = document.createElement('label')
	radioLabel.className = 'form-check-label w-100'
	radioLabel.htmlFor = radio.id

	const title = lecture.llm_name || 'Лекция без названия'
	const date = lecture.lecture_date ? new Date(lecture.lecture_date).toLocaleDateString('ru-RU') : 'Дата не указана'
	const topic = lecture.topic || 'Тема не указана'
	const description = lecture.description || 'Описание отсутствует'

	radioLabel.innerHTML = `
		<div class="d-flex flex-column">
			<h6 class="card-title mb-1">${title}</h6>
			<div class="d-flex justify-content-between align-items-center mb-2">
				<span class="badge bg-primary">${topic}</span>
				<small class="text-muted">${date}</small>
			</div>
			<p class="card-text text-muted small mb-0">${description}</p>
		</div>
	`

	radioContainer.appendChild(radio)
	radioContainer.appendChild(radioLabel)
	cardBody.appendChild(radioContainer)
	card.appendChild(cardBody)

	radio.addEventListener('change', function () {
		if (this.checked) {
			selectedLecture = lecture
			updateLectureData()
			document.getElementById('importLectureBtn').disabled = false
		}
	})

	return card
}



function updateLectureData() {
	if (selectedLecture) {
		const lectureDataContainer = document.getElementById('lectureData')
		lectureDataContainer.innerHTML = ''

		createConflictResolutionInterface(lectureDataContainer)
	}
}

function createConflictResolutionInterface(container) {
	const fieldConfig = {
		title: {
			supabaseField: 'llm_name',
			type: 'conflict',
			displayName: 'Название'
		},
		author: {
			supabaseField: 'author',
			type: 'conflict',
			displayName: 'Автор'
		},
		description: {
			supabaseField: 'description',
			type: 'conflict',
			displayName: 'Описание'
		},
		tags: {
			supabaseField: 'tags',
			type: 'conflict',
			displayName: 'Теги'
		},
		topic: {
			supabaseField: 'topic',
			type: 'autofill',
			displayName: 'Тема'
		},
		bucket: {
			supabaseField: 'bucket',
			type: 'autofill',
			displayName: 'Bucket'
		},
		path: {
			supabaseField: 'path',
			type: 'autofill',
			displayName: 'Path'
		},
		storage_name: {
			supabaseField: 'storage_name',
			type: 'autofill',
			displayName: 'Storage name'
		},
		supabase_file_id: {
			supabaseField: 'supabase_file_id',
			type: 'autofill',
			displayName: 'ID документа в Supabase'
		},
		lecture_link: {
			supabaseField: 'supabase_download_link',
			type: 'autofill',
			displayName: 'Ссылка на текст лекции'
		}
	}

	const currentValues = getCurrentFormValues()

	const header = document.createElement('h6')
	header.textContent = 'Импорт данных из Supabase:'
	header.className = 'mb-3'
	container.appendChild(header)

	const conflictFields = []
	const autofillFields = []

	Object.entries(fieldConfig).forEach(([ourField, config]) => {
		const ourValue = currentValues[ourField]
		const supabaseValue = selectedLecture[config.supabaseField]

		if (config.type === 'conflict') {
			const ourValueTrimmed = isEmptyValue(ourValue)
			const supabaseValueTrimmed = isEmptyValue(supabaseValue)

			if (!ourValueTrimmed && !supabaseValueTrimmed && hasConflict(ourValue, supabaseValue)) {
				conflictFields.push({ ourField, config, ourValue, supabaseValue })
			} else if (ourValueTrimmed && !supabaseValueTrimmed) {
				if (ourField === 'tags') {
					conflictFields.push({ ourField, config, ourValue, supabaseValue })
				} else {
					autofillFields.push({ ourField, config, supabaseValue })
				}
			}
		} else if (config.type === 'autofill') {
			if (isEmptyValue(ourValue) && !isEmptyValue(supabaseValue)) {
				autofillFields.push({ ourField, config, supabaseValue })
			}
		}
	})

	if (conflictFields.length > 0) {
		const conflictHeader = document.createElement('h6')
		conflictHeader.textContent = 'Разрешение конфликтов:'
		conflictHeader.className = 'mb-3 text-warning'
		container.appendChild(conflictHeader)

		conflictFields.forEach(({ ourField, config, ourValue, supabaseValue }) => {
			createConflictField(container, ourField, ourValue, supabaseValue, config.displayName)
		})
	}

	if (autofillFields.length > 0) {
		const autofillHeader = document.createElement('h6')
		autofillHeader.textContent = 'Будут заполнены автоматически:'
		autofillHeader.className = 'mb-3 mt-4 text-info'
		container.appendChild(autofillHeader)

		const autofillList = document.createElement('div')
		autofillList.className = 'alert alert-info'

		const listItems = autofillFields.map(({ config, supabaseValue }) => {
			const displayValue = Array.isArray(supabaseValue)
				? supabaseValue.join(', ')
				: supabaseValue.toString().substring(0, 50) + (supabaseValue.toString().length > 50 ? '...' : '')
			return `<strong>${config.displayName}:</strong> ${displayValue}`
		}).join('<br>')

		autofillList.innerHTML = listItems
		container.appendChild(autofillList)
	}

	if (conflictFields.length === 0 && autofillFields.length === 0) {
		const noChanges = document.createElement('div')
		noChanges.className = 'alert alert-success'
		noChanges.textContent = 'Нет данных для импорта. Все поля уже заполнены или данные в Supabase отсутствуют.'
		container.appendChild(noChanges)
	}
}

function getCurrentFormValues() {
	const title = (document.getElementById('title')?.value || '').trim()
	const description = (document.getElementById('description')?.textContent || '').trim()

	let tags = []
	if (tagifyElements.tags && tagifyElements.tags.value) {
		tags = tagifyElements.tags.value.map(tag => tag.value)
	}

	let author = []
	if (tagifyElements.author && tagifyElements.author.value) {
		author = tagifyElements.author.value.map(tag => tag.value)
	}

	const topic = document.getElementById('topic')?.value || ''
	const bucket = document.getElementById('bucket')?.value || ''
	const path = document.getElementById('path')?.value || ''
	const storage_name = document.getElementById('storage_name')?.value || ''
	const supabase_file_id = document.getElementById('supabase-file-id')?.value || ''
	const lecture_link = document.getElementById('lecture-link')?.value || ''

	return {
		title,
		description,
		tags,
		author,
		topic,
		bucket,
		path,
		storage_name,
		supabase_file_id,
		lecture_link
	}
}

function isEmptyValue(value) {
	if (!value) return true

	if (Array.isArray(value)) {
		return value.length === 0
	}

	return value.toString().trim() === ''
}

function hasConflict(ourValue, supabaseValue) {
	if (Array.isArray(ourValue) && Array.isArray(supabaseValue)) {
		if (ourValue.length !== supabaseValue.length) return true
		return !ourValue.every(val => supabaseValue.includes(val))
	}

	return ourValue.toString().trim() !== supabaseValue.toString().trim()
}



function createConflictField(container, fieldName, ourValue, supabaseValue, displayName = null) {
	const fieldContainer = document.createElement('div')
	fieldContainer.className = 'conflict-field mb-4 p-3 border rounded'

	const fieldTitle = document.createElement('h6')
	fieldTitle.textContent = displayName || getFieldDisplayName(fieldName)
	fieldTitle.className = 'mb-3'
	fieldContainer.appendChild(fieldTitle)

	const choiceContainer = document.createElement('div')

	if (fieldName === 'tags') {
		choiceContainer.className = 'row'

		const ourColumn = createValueColumn('our', fieldName, ourValue, 'Текущее значение', 'primary')
		choiceContainer.appendChild(ourColumn)

		const supabaseColumn = createValueColumn('supabase', fieldName, supabaseValue, 'Значение из Supabase', 'success')
		choiceContainer.appendChild(supabaseColumn)

		const customColumn = createCustomTagsColumn(fieldName, ourValue, supabaseValue)
		choiceContainer.appendChild(customColumn)

	} else {
		choiceContainer.className = 'row'

		const ourColumn = createValueColumn('our', fieldName, ourValue, 'Текущее значение', 'primary')
		choiceContainer.appendChild(ourColumn)

		const supabaseColumn = createValueColumn('supabase', fieldName, supabaseValue, 'Значение из Supabase', 'success')
		choiceContainer.appendChild(supabaseColumn)
	}

	fieldContainer.appendChild(choiceContainer)
	container.appendChild(fieldContainer)
}

function getFieldDisplayName(fieldName) {
	const displayNames = {
		title: 'Название',
		description: 'Описание',
		tags: 'Теги'
	}
	return displayNames[fieldName] || fieldName
}

function createCustomTagsColumn(fieldName, ourValue, supabaseValue) {
	const column = document.createElement('div')
	column.className = 'col-md-12 mt-3'

	const radioContainer = document.createElement('div')
	radioContainer.className = 'form-check mb-2'

	const radio = document.createElement('input')
	radio.type = 'radio'
	radio.name = `conflict_${fieldName}`
	radio.value = 'custom'
	radio.id = `${fieldName}_custom`
	radio.className = 'form-check-input'

	const radioLabel = document.createElement('label')
	radioLabel.className = 'form-check-label fw-bold text-warning'
	radioLabel.htmlFor = radio.id
	radioLabel.textContent = 'Выбрать теги вручную'

	radioContainer.appendChild(radio)
	radioContainer.appendChild(radioLabel)
	column.appendChild(radioContainer)

	const tagifyContainer = document.createElement('div')
	tagifyContainer.className = 'border rounded p-2 bg-light'
	tagifyContainer.style.display = 'none'

	const tagInput = document.createElement('input')
	tagInput.type = 'text'
	tagInput.className = 'form-control'
	tagInput.id = `custom_tags_${fieldName}`
	tagInput.placeholder = 'Выберите теги...'

	tagifyContainer.appendChild(tagInput)
	column.appendChild(tagifyContainer)

	radio.addEventListener('change', function () {
		if (this.checked) {
			tagifyContainer.style.display = 'block'
			initializeCustomTagify(tagInput, ourValue, supabaseValue)
		}
	})

	const otherRadios = document.querySelectorAll(`input[name="conflict_${fieldName}"]:not(#${fieldName}_custom)`)
	otherRadios.forEach(otherRadio => {
		otherRadio.addEventListener('change', function () {
			if (this.checked) {
				tagifyContainer.style.display = 'none'
			}
		})
	})

	return column
}

function initializeCustomTagify(input, ourValue, supabaseValue) {
	import('@yaireo/tagify').then(({ default: Tagify }) => {
		if (input.tagify) {
			input.tagify.destroy()
		}

		const tagify = new Tagify(input, {
			whitelist: tagifyElements.tags ? tagifyElements.tags.whitelist : [],
			maxTags: 10,
			dropdown: {
				maxItems: 20,
				classname: 'tags-look',
				enabled: 0,
				closeOnSelect: false
			}
		})

		const combinedTags = []

		if (Array.isArray(ourValue)) {
			combinedTags.push(...ourValue)
		}

		if (Array.isArray(supabaseValue)) {
			supabaseValue.forEach(tag => {
				if (!combinedTags.includes(tag)) {
					combinedTags.push(tag)
				}
			})
		}

		if (combinedTags.length > 0) {
			const tagsToAdd = findOrCreateTags(combinedTags)
			tagify.addTags(tagsToAdd)
		}

		input.tagify = tagify
	})
}

function createValueColumn(type, fieldName, value, label, colorClass) {
	const column = document.createElement('div')
	column.className = 'col-md-6'

	const radioContainer = document.createElement('div')
	radioContainer.className = 'form-check mb-2'

	const radio = document.createElement('input')
	radio.type = 'radio'
	radio.name = `conflict_${fieldName}`
	radio.value = type
	radio.id = `${fieldName}_${type}`
	radio.className = 'form-check-input'

	if (type === 'our') {
		radio.checked = true
	}

	const radioLabel = document.createElement('label')
	radioLabel.className = `form-check-label fw-bold text-${colorClass}`
	radioLabel.htmlFor = radio.id
	radioLabel.textContent = label

	radioContainer.appendChild(radio)
	radioContainer.appendChild(radioLabel)
	column.appendChild(radioContainer)

	const valueContainer = document.createElement('div')
	valueContainer.className = `border rounded p-2 bg-light`

	if (fieldName === 'tags' && Array.isArray(value)) {
		if (value.length === 0) {
			valueContainer.innerHTML = '<em class="text-muted">Теги не заданы</em>'
		} else {
			valueContainer.innerHTML = value.map(tag =>
				`<span class="badge bg-secondary me-1">${tag}</span>`
			).join('')
		}
	} else {
		valueContainer.textContent = value || 'Не заполнено'
		if (!value) {
			valueContainer.className += ' text-muted'
			valueContainer.style.fontStyle = 'italic'
		}
	}

	column.appendChild(valueContainer)
	return column
}

function importSelectedLecture() {
	if (selectedLecture) {
		const resolvedValues = getResolvedValues()

		applyResolvedValues(resolvedValues)

		const modal = Modal.getInstance(document.getElementById('supabaseLecturesModal'))
		modal.hide()

		showOkToast('Данные лекции импортированы')
	}
}

function getResolvedValues() {
	const fieldConfig = {
		title: {
			supabaseField: 'llm_name',
			type: 'conflict'
		},
		author: {
			supabaseField: 'author',
			type: 'conflict'
		},
		description: {
			supabaseField: 'description',
			type: 'conflict'
		},
		tags: {
			supabaseField: 'tags',
			type: 'conflict'
		},
		topic: {
			supabaseField: 'topic',
			type: 'autofill'
		},
		bucket: {
			supabaseField: 'bucket',
			type: 'autofill'
		},
		path: {
			supabaseField: 'path',
			type: 'autofill'
		},
		storage_name: {
			supabaseField: 'storage_name',
			type: 'autofill'
		},
		supabase_file_id: {
			supabaseField: 'supabase_file_id',
			type: 'autofill'
		},
		lecture_link: {
			supabaseField: 'supabase_download_link',
			type: 'autofill'
		}
	}

	const resolvedValues = {}
	const currentValues = getCurrentFormValues()

	Object.entries(fieldConfig).forEach(([ourField, config]) => {
		const supabaseValue = selectedLecture[config.supabaseField]

		if (config.type === 'conflict') {
			const radioButtons = document.querySelectorAll(`input[name="conflict_${ourField}"]`)

			if (radioButtons.length > 0) {
				const selectedRadio = document.querySelector(`input[name="conflict_${ourField}"]:checked`)

				if (selectedRadio) {
					if (selectedRadio.value === 'our') {
						resolvedValues[ourField] = 'keep_current'
					} else if (selectedRadio.value === 'custom' && ourField === 'tags') {
						const customTagInput = document.getElementById(`custom_tags_${ourField}`)
						if (customTagInput && customTagInput.tagify) {
							const customTags = customTagInput.tagify.value.map(tag => tag.value)
							resolvedValues[ourField] = customTags
						} else {
							resolvedValues[ourField] = 'keep_current'
						}
					} else {
						resolvedValues[ourField] = supabaseValue
					}
				}
			} else {
				if (isEmptyValue(currentValues[ourField]) && !isEmptyValue(supabaseValue)) {
					resolvedValues[ourField] = supabaseValue
				}
			}
		} else if (config.type === 'autofill') {
			if (isEmptyValue(currentValues[ourField]) && !isEmptyValue(supabaseValue)) {
				resolvedValues[ourField] = supabaseValue
			}
		}
	})

	return resolvedValues
}

function applyResolvedValues(resolvedValues) {
	Object.entries(resolvedValues).forEach(([field, value]) => {
		if (value === 'keep_current') return

		switch (field) {
			case 'title':
				const titleInput = document.getElementById('title')
				if (titleInput && value) {
					titleInput.value = value
				}
				break

			case 'author':
				if (tagifyElements.author) {
					tagifyElements.author.removeAllTags()
					if (value) {
						tagifyElements.author.addTags([{ value }])
					}
				}
				break

			case 'description':
				const descriptionDiv = document.getElementById('description')
				if (descriptionDiv && value) {
					descriptionDiv.textContent = value
				}
				break

			case 'tags':
				if (tagifyElements.tags && value) {
					tagifyElements.tags.removeAllTags()

					let tagNames = []
					if (Array.isArray(value)) {
						tagNames = value
					} else if (typeof value === 'string') {
						tagNames = value.split(',').map(tag => tag.trim()).filter(tag => tag)
					}

					if (tagNames.length > 0) {
						const tagsToAdd = findOrCreateTags(tagNames)
						tagifyElements.tags.addTags(tagsToAdd)
					}
				}
				break
			case 'topic':
				const topicInput = document.getElementById('topic')
				if (topicInput && value) {
					topicInput.value = value
				}
				break
			case 'bucket':
				const bucketInput = document.getElementById('bucket')
				if (bucketInput && value) {
					bucketInput.value = value
				}
				break
			case 'path':
				const pathInput = document.getElementById('path')
				if (pathInput && value) {
					pathInput.value = value
				}
				break
			case 'storage_name':
				const storageNameInput = document.getElementById('storage_name')
				if (storageNameInput && value) {
					storageNameInput.value = value
				}
				break
			case 'supabase_file_id':
				const supabaseFileIdInput = document.getElementById('supabase-file-id')
				if (supabaseFileIdInput && value) {
					supabaseFileIdInput.value = value
				}
				break
			case 'lecture_link':
				const lectureLinkInput = document.getElementById('lecture-link')
				if (lectureLinkInput && value) {
					lectureLinkInput.value = value
				}
				break
		}
	})
}

function findOrCreateTags(tagNames) {
	const tagsToAdd = []

	tagNames.forEach(tagName => {
		const trimmedTagName = tagName.trim()
		if (!trimmedTagName) return

		const existingTag = tagifyElements.tags.whitelist?.find(tag =>
			tag.value && tag.value.toLowerCase().trim() === trimmedTagName.toLowerCase()
		)

		if (existingTag) {
			tagsToAdd.push({
				value: existingTag.value,
				key: existingTag.key,
				color: existingTag.color,
				bgColor: existingTag.bgColor
			})
		} else {
			tagsToAdd.push({
				value: trimmedTagName
			})
		}
	})

	return tagsToAdd
}

function getLectureDate() {
	const momentDate = moment(document.getElementById('date').value, 'YYYY.MM.DD')

	if (!momentDate.isValid()) {
		showErrorToast('Заполните дату')

		throw new Error('Invalid date')
	}

	return momentDate.format('YYYY-MM-DD')
}

